import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoice-modal-detail',
  templateUrl: './invoice-modal-detail.component.html',
  styleUrls: ['./invoice-modal-detail.component.css']
})
export class InvoiceModalDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
